import { Contract } from 'ethers';
import contractABI from 'abis/HyperVault.json';
import ganeshABI from 'abis/ganeshVault.json';
import nativeWithdrawABI from 'abis/WithdrawalManager.json';
import withdrawABI from 'abis/withdrawManager.json';

export const getNativeDepositContract = (
	address: string,
	provider: any,
): Contract => {
	return new Contract(address, contractABI, provider);
};

export const getDepositContract = (
	address: string,
	provider: any,
): Contract => {
	return new Contract(address, ganeshABI, provider);
};

export const getWithdrawalContract = (
	address: string,
	provider: any,
): Contract => {
	return new Contract(address, withdrawABI, provider);
};

export const getNativeWithdrawalContract = (
	address: string,
	provider: any,
): Contract => {
	return new Contract(address, nativeWithdrawABI, provider);
};
